import { ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from './UsageSummeryContainer.module.scss';

interface IProps {
  title: string | ReactNode;
  children: ReactNode;
}

const UsageSummeryContainer = (props: IProps) => {
  return (
    <Row>
      <Col className={['mt-4', styles.usageSummeryContainer].join(' ')}>
        <Row>
          <Col className={['py-2 px-4', styles.header].join(' ')}>
            {props.title}
          </Col>
        </Row>
        <Row>
          <Col className={styles.body}>{props.children}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default UsageSummeryContainer;
